import React, {Component} from 'react';
import {Button, Col, Row} from "react-bootstrap";
import {SketchPicker} from 'react-color';
import Colour_Picker from '../../components/Colour_Picker';
import reactCSS from 'reactcss';
import "./style.css";
import DesignResourcesPanel from '../../components/designResourcesPanel';
import Switcher from '../../components/Switcher';


const text_effect_presets = [
    {src: 'uploads/text_effects/glow_soft.png',value:{stroke: false,strokeSize: 5,strokeColor: '#000000',glow: true,glowColor: '#FF841F',glowIntensity: 50,glowOpacity: 1,shadow: false,shadows: [{shadowColor: '#aaaaaa', r: 2,theta: 116,blur: 2,opacity: 1}],displayStrokeColorPicker:false,displayShadowColorPicker:false,displayGlowColorPicker:false}},
    {src: 'uploads/text_effects/glow_medium.png',value:{stroke: false,strokeSize: 5,strokeColor: '#000000',glow: true,glowColor: '#FF841F',glowIntensity: 25,glowOpacity: 1,shadow: false,shadows: [{shadowColor: '#aaaaaa', r: 2,theta: 116,blur: 2,opacity: 1}],displayStrokeColorPicker:false,displayShadowColorPicker:false,displayGlowColorPicker:false}},
    {src: 'uploads/text_effects/stroke_medium.png',value:{stroke: true,strokeSize: 3,strokeColor: '#000000',glow: false,glowColor: '#aaaaaa',glowIntensity: 50,glowOpacity: 1,shadow: false,shadows: [{shadowColor: '#aaaaaa', r: 2,theta: 116,blur: 2,opacity: 1}],displayStrokeColorPicker:false,displayShadowColorPicker:false,displayGlowColorPicker:false}},
    {src: 'uploads/text_effects/stroke_thick.png',value:{stroke: true,strokeSize: 5,strokeColor: '#000000',glow: false,glowColor: '#aaaaaa',glowIntensity: 50,glowOpacity: 1,shadow: false,shadows: [{shadowColor: '#aaaaaa', r: 2,theta: 116,blur: 2,opacity: 1}],displayStrokeColorPicker:false,displayShadowColorPicker:false,displayGlowColorPicker:false}},
    {src: 'uploads/text_effects/shadow_soft.png',value:{stroke: false,strokeSize: 5,strokeColor: '#000000',glow: false,glowColor: '#aaaaaa',glowIntensity: 50,glowOpacity: 1,shadow: true,shadows: [{shadowColor: '#aaaaaa', r: (18/20),theta: 30,blur: 5,opacity: 0.7}],displayStrokeColorPicker:false,displayShadowColorPicker:false,displayGlowColorPicker:false}},
    {src: 'uploads/text_effects/shadow_hard.png',value:{stroke: false,strokeSize: 5,strokeColor: '#000000',glow: false,glowColor: '#aaaaaa',glowIntensity: 50,glowOpacity: 1,shadow: true,shadows: [{shadowColor: '#aaaaaa', r: (18/20),theta: 30,blur: 0,opacity: 1}],displayStrokeColorPicker:false,displayShadowColorPicker:false,displayGlowColorPicker:false}},
    {src: 'uploads/text_effects/stroke_glow.png',value:{stroke: true,strokeSize: 65/20,strokeColor: '#000000',glow: true,glowColor: '#FF841F',glowIntensity: 30,glowOpacity: 1,shadow: false,shadows: [{shadowColor: '#aaaaaa', r: 2,theta: 116,blur: 2,opacity: 1}],displayStrokeColorPicker:false,displayShadowColorPicker:false,displayGlowColorPicker:false}},
    {src: 'uploads/text_effects/stroke_shadow.png',value:{stroke: true,strokeSize: 65/20,strokeColor: '#000000',glow: false,glowColor: '#aaaaaa',glowIntensity: 50,glowOpacity: 1,shadow: true,shadows: [{shadowColor: '#aaaaaa', r: (18/20),theta: 30,blur: 5,opacity: 0.8}],displayStrokeColorPicker:false,displayShadowColorPicker:false,displayGlowColorPicker:false}}
];

window.crop_presets = async () => {
    for (var i = 0; i < text_effect_presets.length; i++) {
        var img = await window.loadStaticImage(text_effect_presets[i].src);
        var canvas = window.document.createElement('canvas');
        var crop_width = 0.35*img.width;
        var crop_height = 0.35*img.height;
        canvas.width = crop_width;
        canvas.height = crop_height;
        var context = canvas.getContext('2d');
        var dx = (img.width - crop_width)/2;
        var dy = (img.height - crop_height)/2;

        context.drawImage(img,-dx,-dy,img.width,img.height);

        var win = window.open();
        win.document.write('<iframe src="' + canvas.toDataURL()  + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
    }
}

class TextEffectsPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            //stroke
            stroke: false,
            strokeSize: 40,
            strokeColor: '#0000ff',
            //glow
            glow: false,
            glowColor: '#aaaaaa',
            glowIntensity: 50,
            glowOpacity: 100,
            //shadow
            shadow: false,
            shadows: [{
                shadowColor: '#aaaaaa', 
                r: 40,
                theta: 116,
                blur: 40,
                opacity: 100
            }],
            displayStrokeColorPicker:false,
            displayShadowColorPicker:false,
            displayGlowColorPicker:false
        };
    }

    set_state = async state => new Promise(resolve => this.setState(state, resolve));

    isValidInput = (inp, min, max) => {
        if (inp === "") return true;
        let val = parseFloat(inp);
        return (!isNaN(val) && val >= min && val <= max);
    };

    apply_text_effect_preset = (preset) => {
        var values = JSON.parse(JSON.stringify(preset.value));

        values.shadows[0].opacity *= 100;
        values.shadows[0].r *= 20;
        values.shadows[0].blur *= 20;

        values.glowOpacity *= 100;
        values.strokeSize *= 20;

        this.set_state(values);
        this.props.apply_text_effects(preset.value);
    }

    strokeOnClick = () => {
        var values = {stroke: !this.state.stroke}
        this.set_state(values);
        this.props.apply_text_effects(values);
    }

    shadowOnClick = () => {
        var values = {shadow: !this.state.shadow}
        this.set_state(values);
        this.props.apply_text_effects(values);
    }

    glowOnClick = () => {
        var values = {glow: !this.state.glow}
        this.set_state(values);
        this.props.apply_text_effects(values);
    }


    updateFields = function(value){
        var updates = {}
        for(var key in value){
            if(this.state[key] != undefined){
                if(key == 'shadows'){
                    var derefed = JSON.parse(JSON.stringify(value[key]));
                    for (var i = 0; i < derefed.length; i++) {
                        derefed[i].opacity *= 100;
                        derefed[i].r *= 20;
                        derefed[i].blur *= 20;
                    }

                    updates[key] = derefed;
                }else if(key == 'glowOpacity'){
                    updates[key] = 100*value[key];
                }else if(key == 'strokeSize'){
                    updates[key] = 20*value[key];
                }else{
                    updates[key] = value[key];
                }
            }
        }

        this.setState(updates)
    }

    handleTextEffectsOnChange = (event) => {
        var min = 0
        var max = 100
        

        if(event.target.name === 'shadows0_theta') {
            min = -180;
            max = 180;
        }

        if (event.target.name.includes('olor') || this.isValidInput(event.target.value, min, max)) {
            var name = event.target.name;
            var value = event.target.value;
            if(name.includes('shadows0_')){
                name = name.split('shadows0_')[1];
                var value_text = value;
                if(name == 'opacity'){
                    value_text /= 100;
                }
                if(name == 'r'){
                    value_text /= 20;
                }
                if(name == 'blur'){
                    value_text /= 20;
                }


                var values = {}
                values['shadows'] = this.state.shadows;
                values['shadows'][0][[name]] = value;

                var values_text = JSON.parse(JSON.stringify(values));
                values_text['shadows'][0].r /= 20;
                values_text['shadows'][0].blur /= 20;
                values_text['shadows'][0].opacity /= 100;

                this.set_state(values);
                this.props.apply_text_effects(values_text);
            }else{
                var value_text = value;
                if(name == 'glowOpacity'){
                    value_text /= 100;
                }
                if(name == 'strokeSize'){
                    value_text /= 20;
                }

                var values = {}
                values[[name]] = value;

                var values_text = {}
                values_text[[name]] = value_text;

                this.set_state(values);
                this.props.apply_text_effects(values_text);
            }
        }
    };

    hideResetBtn = () => (
            this.state.brightness  == 0 &&
            this.state.contrast == 0 &&
            this.state.saturation == 0 &&
            this.state.tint == 0 &&
            this.state.blur == 0 &&
            this.state.x_process == 0 &&
            this.state.vignette == 0
    );

    resetInputs = () => {
        var reset_state = {
            //stroke
            stroke: false,
            strokeSize: 40,
            strokeColor: '#0000ff',
            //glow
            glow: false,
            glowColor: '#aaaaaa',
            glowIntensity: 50,
            glowOpacity: 100,
            //shadow
            shadow: false,
            shadows: [{
                shadowColor: '#aaaaaa', 
                r: 40,
                theta: 116,
                blur: 40,
                opacity: 100
            }],
            displayStrokeColorPicker:false,
            displayShadowColorPicker:false,
            displayGlowColorPicker:false
        }
        this.setState(reset_state)

        var derefed = JSON.parse(JSON.stringify(reset_state));

        for (var i = 0; i < derefed.shadows.length; i++) {
            derefed.shadows[i].opacity /= 100
            derefed.shadows[i].r /= 20
            derefed.shadows[i].blur /= 20
        }

        derefed.glowOpacity /= 100 
        derefed.strokeSize /= 20 

        this.props.apply_text_effects(derefed);
    };

    handleClickStrokeColorPicker = () => {
        this.setState({ displayStrokeColorPicker: !this.state.displayStrokeColorPicker })
    };

    handleCloseStrokeColorPicker = () => {
        this.setState({ displayStrokeColorPicker: false })
    };

    stroke_dropper = () => {
        const styles = reactCSS({
            'default': {
              color: {
                width: '30px',
                height: '30px',
                borderRadius: '15px',
                'border': '1px',
                background: this.state.strokeColor,
              },
              swatch: {
                padding: '2.5px',
                borderRadius: '15px',
                display: 'inline-block',
                cursor: 'pointer',
              },
              popover: {
                position: 'absolute',
                zIndex: '2',
              },
              cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
                zIndex: '-1'
              },
            },
        });

        return (<div>
            <Row style={{marginBottom : 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize:'1.5rem'}}>
                    Size
                </Col>
                <Col xs={7}>
                    <input type="range" className="adjustment-slider" name="strokeSize" min="0" max="100" value={this.state.strokeSize} onChange={(e) => this.handleTextEffectsOnChange(e)}/>
                </Col>
                <Col className="filter-adjustment-col" xs={2}>
                    <input type="text" className="adjustment-input-text" name="strokeSize" onChange={(e) => this.handleTextEffectsOnChange(e)} value={this.state.strokeSize}/>
                </Col>
            </Row>
            <Row style={{marginBottom : 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize:'1.5rem'}}>
                    Color
                </Col>
                <Col xs={9} className="adjustment-controls-text" style={{float:'right',paddingTop:0}}>
                    <div >
                        <div style={ styles.swatch } onClick={ this.handleClickStrokeColorPicker }>
                        <div style={ styles.color } />
                        </div>
                        { this.state.displayStrokeColorPicker ? <div style={ styles.popover }>
                        <div style={ styles.cover } onClick={ this.handleCloseStrokeColorPicker }/>
                        <Colour_Picker user={this.props.user}  presetColors={['#ffffff','#f3ec3a','#f9bd17','#f99b1d','#f15523','#ef3124','#DE0081','#a71e48','#7c3597','#463191','#000000','#3d5dac','#1296ce','#63b145','#19BC81','#d0dd36']} disableAlpha={true} color={styles.color.background} onChange={ (e) => {this.handleTextEffectsOnChange({target:{value:e.hex,name:'strokeColor'}}) }} />
                        </div> : null }
                    </div>
                </Col>
            </Row>
        </div>)
    }

    handleClickShadowColorPicker = () => {
        this.setState({ displayShadowColorPicker: !this.state.displayShadowColorPicker })
    };

    handleCloseShadowColorPicker = () => {
        this.setState({ displayShadowColorPicker: false })
    };

    shadow_dropper = () => {
        const styles = reactCSS({
            'default': {
              color: {
                width: '30px',
                height: '30px',
                borderRadius: '15px',
                'border': '1px',
                background: this.state.shadows[0].shadowColor,
              },
              swatch: {
                padding: '2.5px',
                borderRadius: '15px',
                display: 'inline-block',
                cursor: 'pointer',
              },
              popover: {
                position: 'absolute',
                zIndex: '2',
              },
              cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
                zIndex: '-1'
              },
            },
        });

        return (<div>
            <Row style={{marginBottom : 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize:'1.5rem'}}>
                    Offset
                </Col>
                <Col xs={7}>
                    <input type="range" className="adjustment-slider" name="shadows0_r" min="0" max="100" value={this.state.shadows[0].r} onChange={(e) => this.handleTextEffectsOnChange(e)}/>
                </Col>
                <Col className="filter-adjustment-col" xs={2}>
                    <input type="text" className="adjustment-input-text" name="shadows0_r" onChange={(e) => this.handleTextEffectsOnChange(e)} value={this.state.shadows[0].r}/>
                </Col>
            </Row>
            <Row style={{marginBottom : 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize:'1.5rem'}}>
                    Direction
                </Col>
                <Col xs={7}>
                    <input type="range" className="adjustment-slider" name="shadows0_theta" min="-180" max="180" value={this.state.shadows[0].theta} onChange={(e) => this.handleTextEffectsOnChange(e)}/>
                </Col>
                <Col className="filter-adjustment-col" xs={2}>
                    <input type="text" className="adjustment-input-text" name="shadows0_theta" onChange={(e) => this.handleTextEffectsOnChange(e)} value={this.state.shadows[0].theta}/>
                </Col>
            </Row>
            <Row style={{marginBottom : 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize:'1.5rem'}}>
                    Blur
                </Col>
                <Col xs={7}>
                    <input type="range" className="adjustment-slider" name="shadows0_blur" min="0" max="100" value={this.state.shadows[0].blur} onChange={(e) => this.handleTextEffectsOnChange(e)}/>
                </Col>
                <Col className="filter-adjustment-col" xs={2}>
                    <input type="text" className="adjustment-input-text" name="shadows0_blur" onChange={(e) => this.handleTextEffectsOnChange(e)} value={this.state.shadows[0].blur}/>
                </Col>
            </Row>
            <Row style={{marginBottom : 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize:'1.5rem'}}>
                    Opacity
                </Col>
                <Col xs={7}>
                    <input type="range" className="adjustment-slider" name="shadows0_opacity" min="0" max="100" value={this.state.shadows[0].opacity} onChange={(e) => this.handleTextEffectsOnChange(e)}/>
                </Col>
                <Col className="filter-adjustment-col" xs={2}>
                    <input type="text" className="adjustment-input-text" name="shadows0_opacity" onChange={(e) => this.handleTextEffectsOnChange(e)} value={this.state.shadows[0].opacity}/>
                </Col>
            </Row>
            <Row style={{marginBottom : 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize:'1.5rem'}}>
                    Color
                </Col>
                <Col xs={9} className="adjustment-controls-text" style={{float:'right',paddingTop:0}}>
                    <div >
                        <div style={ styles.swatch } onClick={ this.handleClickShadowColorPicker }>
                        <div style={ styles.color } />
                        </div>
                        { this.state.displayShadowColorPicker ? <div style={ styles.popover }>
                        <div style={ styles.cover } onClick={ this.handleCloseShadowColorPicker }/>
                        <Colour_Picker user={this.props.user}  presetColors={['#ffffff','#f3ec3a','#f9bd17','#f99b1d','#f15523','#ef3124','#DE0081','#a71e48','#7c3597','#463191','#000000','#3d5dac','#1296ce','#63b145','#19BC81','#d0dd36']} disableAlpha={true} color={styles.color.background} onChange={ (e) => {this.handleTextEffectsOnChange({target:{value:e.hex,name:'shadows0_shadowColor'}}) }} />
                        </div> : null }
                    </div>
                </Col>
            </Row>
        </div>)
    }


    handleClickGlowColorPicker = () => {
        this.setState({ displayGlowColorPicker: !this.state.displayGlowColorPicker })
    };

    handleCloseGlowColorPicker = () => {
        this.setState({ displayGlowColorPicker: false })
    };

    glow_dropper = () => {
        const styles = reactCSS({
            'default': {
              color: {
                width: '30px',
                height: '30px',
                borderRadius: '15px',
                'border': '1px',
                background: this.state.glowColor,
              },
              swatch: {
                padding: '2.5px',
                borderRadius: '15px',
                display: 'inline-block',
                cursor: 'pointer',
              },
              popover: {
                position: 'absolute',
                zIndex: '2',
              },
              cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
                zIndex: '-1'
              },
            },
        });

        return (<div>
            <Row style={{marginBottom : 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize:'1.5rem'}}>
                    Intensity
                </Col>
                <Col xs={7}>
                    <input type="range" className="adjustment-slider" name="glowIntensity" min="0" max="100" value={this.state.glowIntensity} onChange={(e) => this.handleTextEffectsOnChange(e)}/>
                </Col>
                <Col className="filter-adjustment-col" xs={2}>
                    <input type="text" className="adjustment-input-text" name="glowIntensity" onChange={(e) => this.handleTextEffectsOnChange(e)} value={this.state.glowIntensity}/>
                </Col>
            </Row>
            <Row style={{marginBottom : 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize:'1.5rem'}}>
                    Opacity
                </Col>
                <Col xs={7}>
                    <input type="range" className="adjustment-slider" name="glowOpacity" min="0" max="100" value={this.state.glowOpacity} onChange={(e) => this.handleTextEffectsOnChange(e)}/>
                </Col>
                <Col className="filter-adjustment-col" xs={2}>
                    <input type="text" className="adjustment-input-text" name="glowOpacity" onChange={(e) => this.handleTextEffectsOnChange(e)} value={this.state.glowOpacity}/>
                </Col>
            </Row>
            <Row style={{marginBottom : 10}}>
                <Col xs={3} className="adjustment-controls-text" style={{fontSize:'1.5rem'}}>
                    Color
                </Col>
                <Col xs={9} className="adjustment-controls-text" style={{float:'right',paddingTop:0}}>
                    <div >
                        <div style={ styles.swatch } onClick={ this.handleClickGlowColorPicker }>
                        <div style={ styles.color } />
                        </div>
                        { this.state.displayGlowColorPicker ? <div style={ styles.popover }>
                        <div style={ styles.cover } onClick={ this.handleCloseGlowColorPicker }/>
                        <Colour_Picker user={this.props.user}  presetColors={['#ffffff','#f3ec3a','#f9bd17','#f99b1d','#f15523','#ef3124','#DE0081','#a71e48','#7c3597','#463191','#000000','#3d5dac','#1296ce','#63b145','#19BC81','#d0dd36']} disableAlpha={true} color={styles.color.background} onChange={ (e) => {this.handleTextEffectsOnChange({target:{value:e.hex,name:'glowColor'}}) }} />
                        </div> : null }
                    </div>
                </Col>
            </Row>
        </div>)
    }


    render() {
        return (
            <div>
                <Row style={{marginBottom : 10}}>
                    <Col xs={12} style={{borderBottom : '1px solid #cccccc', display : 'table', 'marginBottom' : 20, paddingTop : 5, paddingBottom : 5}}>
                        <span style={{textAlign : 'left', fontWeight : 300, verticalAlign : 'middle', display : 'table-cell', height : 40, fontSize : '1.4rem', cursor: 'pointer'}}></span>
                        {!this.hideResetBtn()?(<Button onClick={this.resetInputs} className="btn-toolbar" style={{float : 'right', fontWeight : 700}}>Reset</Button>):null}
                    </Col>
                </Row>
                <Row>
                    <Switcher Dropper={this.stroke_dropper} show_dropper={this.state.stroke} trigger_on_click={this.strokeOnClick} title="Stroke" />
                    <Switcher Dropper={this.shadow_dropper} show_dropper={this.state.shadow} trigger_on_click={this.shadowOnClick} title="Shadow"  />
                    <Switcher Dropper={this.glow_dropper} show_dropper={this.state.glow} trigger_on_click={this.glowOnClick} title="Glow" />
                </Row>
                <Row>
                    <DesignResourcesPanel
                        on_click={this.apply_text_effect_preset}
                        image_height={'126px'}
                        col_size={6}
                        resources={text_effect_presets}/>
                </Row>
            </div>
        );
    }
}

export default TextEffectsPanel;